import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/CFooter/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/CHeader/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/app/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/app/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/app/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/app/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/slices/About/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/ContactUs/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/HomepageIntro/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/NavItems/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/ProjectInfo/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/Projects/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/ProjectsList/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/Testimonials/index.js");
;
import(/* webpackMode: "eager" */ "/app/slices/Text/index.js");
